import React, { useCallback, useMemo, useState } from "react";
import { eventsApi } from "../api/eventsApi";
import { API_BASES } from "../../config/apiConfig";

function digitsPhone(phone) {
  var d = String(phone || "").replace(/\D/g, "");
  if (d.length >= 10) return d.slice(-10);
  return "";
}

/**
 * Post-payment invoice actions: send on WhatsApp + share + download fallback.
 * Hidden until payment is recorded as successful. Transaction stays successful
 * even if the customer skips WhatsApp.
 */
export function InvoiceWhatsAppActions(props) {
  var kind = props.kind || "event_booking";
  var bookingId = props.bookingId;
  var paid = !!props.paid;
  var phone = props.phone || "";
  var allowWhatsApp = props.allowWhatsApp !== false;
  var className = props.className || "";
  var primaryClass = props.primaryClass || "bk-btn bk-btn--primary";
  var ghostClass = props.ghostClass || "bk-btn bk-btn--ghost";

  var _wa = useState({ busy: false, sent: false, err: "" });
  var waState = _wa[0], setWaState = _wa[1];

  var downloadUrl =
    API_BASES.EVENTS +
    "/receipt/" +
    encodeURIComponent(kind) +
    "/" +
    encodeURIComponent(bookingId || "") +
    "/?fmt=html";

  var shareHref = useMemo(
    function () {
      var digits = digitsPhone(phone);
      var text = "Your invoice: " + downloadUrl;
      var q = "text=" + encodeURIComponent(text);
      if (digits) return "https://wa.me/91" + digits + "?" + q;
      return "https://wa.me/?" + q;
    },
    [phone, downloadUrl]
  );

  var handleSend = useCallback(
    function () {
      if (!bookingId) return;
      setWaState({ busy: true, sent: false, err: "" });
      eventsApi
        .receiptSendWhatsApp(kind, bookingId)
        .then(function () {
          setWaState({ busy: false, sent: true, err: "" });
        })
        .catch(function (ex) {
          setWaState({
            busy: false,
            sent: false,
            err: ex.message || "Could not send automatically. Use Share on WhatsApp or download the invoice.",
          });
        });
    },
    [kind, bookingId]
  );

  if (!paid || !bookingId) return null;

  var canAutoSend = allowWhatsApp && !!digitsPhone(phone);

  return (
    <div className={"ev-invoice-actions " + className}>
      {canAutoSend ? (
        <button
          type="button"
          className={primaryClass + " ev-invoice-actions__wa"}
          onClick={handleSend}
          disabled={waState.busy || waState.sent}
        >
          {waState.busy
            ? "Sending…"
            : waState.sent
            ? "✓ Invoice sent on WhatsApp"
            : "Send Invoice on WhatsApp"}
        </button>
      ) : null}
      {allowWhatsApp ? (
        <a
          className={(canAutoSend ? ghostClass : primaryClass) + " ev-invoice-actions__wa"}
          href={shareHref}
          target="_blank"
          rel="noreferrer"
        >
          {canAutoSend ? "Share on WhatsApp" : "Send Invoice on WhatsApp"}
        </a>
      ) : null}
      <a className={ghostClass} href={downloadUrl} target="_blank" rel="noreferrer">
        Download invoice
      </a>
      {waState.err ? <p className="ev-invoice-actions__err">{waState.err}</p> : null}
    </div>
  );
}

export default InvoiceWhatsAppActions;
